import { TableFilterButtons, TableFilterCard, TableFilterSection } from '@repo/ui/Table';
import { SelectorInputField, TextInputField } from '@repo/ui/Form';
import { registerInput } from '@repo/hooks/useZodForm';
import { useZodFormContext } from '@repo/hooks/useZodFormContext';
import type { SelectInputOptions } from '@repo/types/Types';

import { useFormState } from 'react-hook-form';

import { Mercury } from '@repo/types/Models';
import { POLICIES } from '@/lib/Authorization';
import { useUser } from '@repo/hooks/useUser';
import { useAccount } from '@/hooks/useAccount';

interface WhitelistTableFilterProps {
  SCOPES: SelectInputOptions;
  queryList: Mercury.Queries.QueryList;
}

const WhitelistTableFilter = ({ SCOPES, queryList }: WhitelistTableFilterProps) => {
  const user = useUser();
  const account = useAccount();
  const accountId = account.id;

  const filter = useZodFormContext();
  useFormState();
  if (!filter) {
    return <></>;
  }

  return (
    <TableFilterCard>
      <TableFilterSection>
        <TextInputField label="Address" {...registerInput(filter, 'address')} />

        <TextInputField label="Name" {...registerInput(filter, 'name')} />
        <SelectorInputField label="Scope" options={SCOPES} {...registerInput(filter, 'scope')} />
      </TableFilterSection>

      <TableFilterButtons className="ml-auto" />
    </TableFilterCard>
  );
};

export default WhitelistTableFilter;
